// extracted by mini-css-extract-plugin
export default {"container":"styles_container__PM02V","image":"styles_image__p5xQg","title":"styles_title__nSCbz","profiles":"styles_profiles__da5Zw"};